package com.arena_web.ui.components.widgets

import androidx.compose.runtime.Composable
import com.arena_web.ui.localization.LocalAppStrings
import com.arena_web.ui.theme.*
import com.arena_web.ui.utils.*
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*

enum class StatusVariant(
    val label: String,
    val countColor: Color,
    val dotColor: Color
) {
    InProgress("In Progress", SportColors.Tennis.secondary, SportColors.Tennis.secondary),           // #34D524
    Upcoming("Upcoming", SportColors.Football.metricsPrimary, AppColors.Primary),                    // dot #0061FF
    Pending("Pending", SportColors.Basketball.primary, SportColors.Basketball.secondary),            // dot #E88908
    Completed("Completed", AppColors.Text.Subtle, SportColors.Basketball.secondary)                  // dot #E88908
}

@Composable
fun StatusIndicator(
    variant: StatusVariant,
    count: Int = 1,
    modifier: Modifier = Modifier
) {
    val t = LocalAppStrings.current
    val variantLabel = when (variant) {
        StatusVariant.InProgress -> t.widgetStatusInProgress
        StatusVariant.Upcoming -> t.widgetStatusUpcoming
        StatusVariant.Pending -> t.widgetStatusPending
        StatusVariant.Completed -> t.widgetStatusCompleted
    }
    // Outer pill
    Row(
        modifier
            .sHeight(44)
            .sBorderRadius(22)
            .sPadding(6, 14)
            .styleModifier {
                property("gap", if (variant == StatusVariant.InProgress) s(6) else s(4))
                property("border", "0.3px solid transparent")
                property("background",
                    "${AppGradients.InteractiveSecondary} padding-box, " +
                    "linear-gradient(0deg, #0A142A, #0A142A) padding-box, " +
                    "${AppGradients.ButtonBorderGradientPrimary} border-box")
            },
        verticalAlignment = Alignment.CenterVertically
    ) {
        // Status label
        SpanText(
            variantLabel,
            modifier = Modifier
                .bodyLMedium()
                .color(AppColors.Text.Secondary)
                .styleModifier { property("white-space", "nowrap") }
        )

        // Count badge (circle)
        val badgeBorderColor = when (variant) {
            StatusVariant.Pending, StatusVariant.Completed -> "rgba(0, 59, 174, 0.2)"
            else -> "rgba(41, 52, 138, 0.2)"
        }

        Box(
            Modifier
                .sSize(24)
                .borderRadius(50.percent)
                .styleModifier {
                    property("background", "linear-gradient(196deg, rgba(60, 121, 241, 0.225) 38%, rgba(5, 4, 12, 0.05) 62%)")
                    property("border", "0.3px solid $badgeBorderColor")
                    property("overflow", "clip")
                },
            contentAlignment = Alignment.Center
        ) {
            SpanText(
                count.toString(),
                modifier = Modifier
                    .bodyLMedium()
                    .color(variant.countColor)
            )
        }
    }
}

@Composable
fun StatusDot(
    variant: StatusVariant,
    modifier: Modifier = Modifier
) {
    Box(
        modifier
            .sSize(8)
            .borderRadius(50.percent)
            .backgroundColor(variant.dotColor)
    )
}
